<template>
    <v-dialog :isActive="open" v-model="open" width="500" class="modal" data-app>
        <div id="popup">
            <div class="header">
                <img v-bind:src="'/img/error.svg'" alt="delete">
                <h2>{{$t('are_you_sure')}}</h2>
                <p>{{$t('descriptions.confirm_popup')}}</p>
            </div>
            <div class="buttons">
                <button v-on:click="cancel()" class="btn" id="cancel">{{$t('cancel')}}</button>
                <button v-on:click="deleteConfirm()" class="btn" id="delete">{{$t('confirm')}}</button>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmPopup',
  props: ['dialog'],
  data () {
    return {
      open: false
    }
  },
  methods: {
    cancel () {
      // close dialog
      this.open = false
      this.$emit('close')
    },
    deleteConfirm () {
      // close dialog
      this.open = false
      this.$emit('confirm')
    }
  },
  watch: {
    'dialog': function () {
      this.open = this.dialog
    },
    'open': function () {
      if (!this.open) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    #popup {
        height: 250px;
        background-color: white;
        .header {
            img {
                display: block;
                text-align: center;
                margin: 0 auto;
                padding-top: 10px;
                width: 75px;
                height: 75px;
            }
            h2, p {
                margin: 0 auto;
                text-align: center;
            }
            padding-bottom: 25px;
        }
        .buttons {
            .btn {
              width: calc( 50% - 20px );
              margin: 0 10px;
              display: inline-block;
              min-width: 40px;
              padding: 0 35px;
              outline: none;
              border: none;
              cursor: pointer;
              text-align: center;
              font-size: 16px;
              border-radius: 3px;
              -webkit-transition: all 0.5s;
              transition: all 0.5s;
              color: #fff;
              height: 40px;
              line-height: 40px;
              text-transform: uppercase;
              // background-color: #fc8926;
              font-family: AvantGarde-Bold;
              max-width: 300px;
              transition: background-color 0.5s ease;

                &#delete {

                border: 1px solid #fc8926;
                background-color: $alert-color-bg;

                &:hover {
                  background-color: rgb(255, 0, 0);
                  border-color: #e78026;
                }

                }

                &#cancel {
                background-color: transparent;
                color: #c55c00;
                border: 1px solid #fc8926;

                &:hover {
                  background-color: #fc8a2623 !important;
                }

                }
            }
        }
    }
</style>
